 import one from '../assets/image/Oval.png'
 import two from '../assets/image/contentTwo.png'
 import three from '../assets/image/contentThree.png'
 import four from '../assets/image/contentFour.png' 

 const reviews = [
  {
    pic: `${one}`,
    content: 'OKTC Social Media has made it so easy for me to connect with other  crypto enthusiasts and stay up-to-date on the latest trends and news!'
  },
  {
    pic: `${two}`,
    content: "I love using this INE! It's so fast and easy to use."
  },
  {
    pic: `${three}`,
    content:  "I've been using this INE app for a while now and I'm really impressed with how responsive it is."
  },
   {
    pic: `${four}`,
    content: "This INE app has a great community. It's easy to connect with others and start conversations."
  },
 ]


 export default reviews